module.exports = __webpack_public_path__ + "img/28.a576f5d6.jpg";